import { render } from "./Footer.vue?vue&type=template&id=589d7685&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=589d7685&scoped=true&lang=css"

import exportComponent from "/home/vv-finance/.jenkins/workspace/pro-pinsen-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589d7685"]])

export default __exports__